/**
 *@ngdoc directive
 *@name cbl.finanza.mf.directives.directive:finTable
 *@restrict E
 *@scope
 *@description Direttiva utilizzata per contenere lo ui-grid
 *@param {Object} data - Oggetto contenente i dati della tabella
 *@param {Object} label - Oggetto contenente i parametri di configurazione della tabella
 *@param {String} [messaggioCustom] - Messaggio personalizzato da far visualizzare al post odi quello standard
 *@param {Function} [modificaRaccomandazione] - Funzione di callback per la modifica di una raccomandazione
 *@param {Function} [visualizzaRaccomandazione] - Funzione di callback per la visualizzazione di una raccomandazione
 *@param {Function} [eliminaRaccomandazione] - Funzione di callback per l'eliminazione di una raccomandazione
 *@param {Function} [valutazioneRaccomandazione] - Funzione di callback per la valutazione di una raccomandazione
 *@param {Function} [eliminaProposta] - Funzione di callback per la rimozione di una proposta
 *@param {Function} [modificaProposta] - Funzione di callback per la modifica di una proposta
 *@param {Function} [modificaRichiesta] - Funzione di callback per la modifica di una richiesta
 *@param {Function} [visualizzaRichiesta] - Funzione di callback per la visualizzazione di una richiesta
 *@param {Function} [gestioneOrdine] - Funzione di callback per la gestione di un ordine
 *@param {Function} [visualizzaOrdine] - Funzione di callback per la visualizzazione di un ordine
 *@param {Function} [acquista] - Funzione di callback per l'aggiunta di una nuova proposta dopo la pressione del tasto (più) sulla tabella portafoglio
 *@param {Function} [vendita] - Funzione di callback per l'aggiunta di una nuova proposta dopo la pressione del tasto (meno) sulla tabella portafoglio
 *@param {Function} [cambio] - Funzione di callback per l'aggiunta di una nuova proposta dopo la pressione del tasto (switch) sulla tabella portafoglio
 *@param {Function} [apriPagina] - Funzione di callback utilizzata per aprire la pagina
 *@param {Boolean} [clickRiga] - Se true abilita il click sulla riga
 *@param {Boolean} [paginazioneEsterna] - Variabile di tipo booleana per indicare alla tabella se utilizzare la paginazione backend o meno
 *@param {Function} [cambioPagina] - Funzione di callback richiamata quando si cambia pagina, da utilizzare quando paginazioneEsterna è true
 *@param {Number} [totalItems] - Numero di elementi totali della tabella, da utilizzare quando paginazioneEsterna è true
 *@param {Number} [itemsPerPage] - Numero di elementi da mostrare per ogni pagina
 *@param {Number} [pageNumber] - Numero di pagina da utilizzare quando si usa la paginazione esterna
 *@param {Function} [abilitaConsulenza] - Funzione di callback richiamata quando si vuole andare nella schermata di abilitaConsulenza su un Dossierù
 *@param {Function} [inserisciOrdine] -Funzione per inserire direttamente l'ordine dalla pagina gestioneOrdine
 *@param {Function} [visualizzaOrdine]- Funzione per visualizzare la pratica dopo aver generato l'ordine alla fine della creazione di una raccomandazione
 *@param {String} [raccomandazioneState]- Variabile per gestire la visualizzazione dei pulsanti della pagina gestione-ordine in raccomandazioni
 */
(function () {
  'use strict';
  angular.module('cbl.finanza.mf.directives').directive('finTable', [
    'FIN_CONSTANTS',
    function (CONSTANTS) {
      var link = function (scope, elem, attrs, model) {};

      var controller = function (
        $scope,
        $state,
        $stateParams,
        labelSrvc,
        uiGridConstants,
        userSrvc
      ) {
        $scope.msg = labelSrvc.getLabel;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.uiGridConstants = uiGridConstants;
        $scope.userSrvc = userSrvc;
        var self = this;
        if (!$scope.rowHeight) {
          $scope.rowHeight = 30;
        }

        $scope.itemsPerPage = $scope.itemsPerPage ? $scope.itemsPerPage : 10;

        if (Array.isArray($scope.data) && $scope.data.length > 0) {
          this.gridOptions = {
            enableSorting: true,
            enableColumnMenus: false,
            enableGrouping: false,
            enableFiltering: true,
            treeRowHeaderAlwaysVisible: false,
            useExternalPagination: $scope.paginazioneEsterna ? true : false,
            paginationPageSizes: [10, 25, 50],
            paginationPageSize: $scope.itemsPerPage,
            paginationCurrentPage: $scope.pageNumber ? $scope.pageNumber : 1,
            totalItems: $scope.totalItems,
            enableRowSelection: $scope.clickAbilitato || false,
            multiSelect: false,
            enableRowHeaderSelection: false,
            enableRowHashing: false,
            showGridFooter: false,
            enableVerticalScrollbar: this.uiGridConstants.scrollbars.NEVER,
            columnDefs: $scope.label,
            data: $scope.data,
            rowHeight: $scope.rowHeight,
            onRegisterApi: function (gridApi) {
              self.gridApi = gridApi;
              if ($scope.paginazioneEsterna) {
                self.gridApi.pagination.on.paginationChanged(
                  $scope,
                  function (newPage, pageSize) {
                    $scope.cambioPagina({
                      pageNumber: newPage,
                      itemsPerPage: pageSize
                    });
                  }
                );
              }
              self.gridApi.selection.on.rowSelectionChanged(
                $scope,
                function (row, evt) {
                  if (evt.target.tagName === 'BUTTON') {
                    return;
                  }
                  if ($scope.clickAbilitato) {
                    $scope.apriPagina({ row: row.entity });
                  }
                }
              );
              self.gridApi.core.on.filterChanged($scope, function () {
                if ($scope.paginazioneEsterna) {
                  $scope.applicaFiltri({ columns: this.grid.columns });
                }
              });
            }
          };
        }

        this.showButtonRaccomandazioni = function (stato, operazione) {
          if (
            stato === CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO &&
            (operazione === 'modifica' || operazione === 'elimina')
          ) {
            return true;
          }
          if (
            stato === CONSTANTS.STATO_RACCOMANDAZIONE.CONSOLIDATA &&
            operazione === 'valutazione'
          ) {
            return true;
          }
          if (operazione === 'copia') {
            return true;
          }
          return false;
        };
        this.getTableHeight = function () {
          return {
            height: 120 + $scope.itemsPerPage * $scope.rowHeight + 'px'
          };
        };
      };

      controller.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        'FinLabelSrvc',
        'uiGridConstants',
        'FinUserSrvc'
      ];

      return {
        restrict: 'E',
        scope: {
          data: '=',
          label: '=',
          messaggioCustom: '@?',
          modificaRaccomandazione: '&?',
          visualizzaRaccomandazione: '&?',
          eliminaRaccomandazione: '&?',
          valutazioneRaccomandazione: '&?',
          eliminaProposta: '&?',
          modificaProposta: '&?',
          visualizzaProposta: '&?',
          modificaRichiesta: '&?',
          visualizzaRichiesta: '&?',
          cambioPiano: '&?',
          gestioneOrdine: '&?',
          visualizzaOrdine: '&?',
          acquista: '&?',
          vendita: '&?',
          cambio: '&?',
          apriPagina: '&?',
          clickAbilitato: '=?',
          paginazioneEsterna: '=?',
          cambioPagina: '&?',
          totalItems: '=?',
          itemsPerPage: '=?',
          pageNumber: '=?',
          applicaFiltri: '&?',
          abilitaConsulenza: '&?',
          copiaRaccomandazione: '&?',
          segnalazioniProposte: '=?',
          leggiAlert: '&?',
          abilitatoConsulenza: '<',
          abilitatoCollocamento: '<',
          rowHeight: '<?',
          inserisciOrdine:'&?'
        },
        controller: controller,
        controllerAs: 'finTableCtrl',
        templateUrl: CONSTANTS.BASE_ROOT + 'widgets/finTable/finTable.html',
        link: link
      };
    }
  ]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finTable/finTableDrct.js
 ** module id = 9
 ** module chunks = 0 1 2
 **/